export enum Account {
  MY_ACCOUNT_BONUS_WALLET = 'MyAccountBonusWalletFocusEvent',
  MY_ACCOUNT_BONUS_WALLET_HOW_TO = 'MyAccountBonusWalletHowToFocusEvent',
  MY_ACCOUNT_BONUS_WALLET_REFRESH = 'MyAccountBonusWalletRefreshFocusEvent',
  MY_ACCOUNT_BONUS_WALLET_FORFEIT = 'MyAccountBonusWalletForfeitFocusEvent',
  MY_ACCOUNT_BONUS_SUMMARY_INIT = 'MyAccountBonusSummaryInit',
  MY_ACCOUNT_BONUS_SUMMARY_COMPLETED = 'MyAccountBonusSummaryCompleted',
  MY_ACCOUNT_BONUS_SUMMARY_FAILURE = 'MyAccountBonusSummaryFailure',
  MY_ACCOUNT_BONUS_SUMMARY_SEARCH = 'MyAccountBonusSummarySearchFocusEvent',
  MY_ACCOUNT_BONUS_SUMMARY_DETAILS = 'MyAccountBonusSummaryDetailsFocusEvent',
  MY_ACCOUNT_DETAILED_TRANSACTION = 'MyAccountDetailedTransactionFocusEvent',
  MY_ACCOUNT_HISTORY_TRANSACTION_REFRESH = 'MyAccountHistoryTransactionRefreshFocusEvent',
  MY_ACCOUNT_HISTORY_TRANSACTION_FILTER = 'MyAccountHistoryTransactionFilterFocusEvent',
  MY_ACCOUNT_HISTORY_TRANSACTION_PAGINATE = 'MyAccountHistoryTransactionPaginateFocusEvent',
  MY_ACCOUNT_TELLER = 'MyAccountTellerFocusEvent',
  MY_ACCOUNT_HISTORY = 'MyAccountHistoryFocusEvent',
  MY_ACCOUNT_SETTINGS = 'MyAccountSettingsFocusEvent',
  MY_ACCOUNT_LOGOUT = 'LogOutInitiatedEvent',
  DOC_VERIFICATION_SUBMIT = 'DocVerificationItemSubmittedEvent',
  DOC_VERIFICATION_ERROR = 'DocVerificationErrorEvent',
  MY_ACCOUNT_PASSWORD_UPDATE_ACTION = 'MyAccountUpdatePasswordActionEvent',
  MY_ACCOUNT_PASSWORD_UPDATE_SUCCESS = 'MyAccountUpdatePasswordSuccessActionEvent',
  MY_ACCOUNT_PASSWORD_UPDATE_FAILURE = 'MyAccountUpdatePasswordFailureActionEvent',
  MY_ACCOUNT_SETTINGS_UPDATE_ACTION = 'MyAccountSettingsActionEvent',
  MY_ACCOUNT_DETAILS_UPDATE_ACTION = 'MyAccountDetailsActionEvent',
  MY_ACCOUNT_ADD_SECONDARY_NUMBER = 'MyAccountSettingsAddSecondaryNumberActionEvent',
  MY_ACCOUNT_DELETE_SECONDARY_NUMBER = 'MyAccountSettingsDeleteSecondaryNumberActionEvent',
  MY_ACCOUNT_CHANGE_PRIMARY_NUMBER = 'MyAccountSettingsChangePrimaryNumberActionEvent',
  MY_ACCOUNT_UPDATE_SECONDARY_NUMBER = 'MyAccountSettingsUpdateSecondaryNumberActionEvent',
  MY_ACCOUNT_UPDATE_EMAIL = 'MyAccountSettingsUpdateEmailActionEvent',
  MY_ACCOUNT_SUM_SUB_ACTION = 'MyAccountSumSubActionEvent',
}
